export enum FileType {
    Archive = "Archive",
    Audio = "Audio",
    Database = "Document/Database",
    Document = "Document/Text",
    Image = "Image",
    Other = "Other",
    Pdf = "Document/Pdf",
    Presentation = "Document/Presentation",
    Spreadsheet = "Document/Spreadsheet",
    Video = "Video"
}
